import axios from 'axios';
import type { TuitionFee } from '../../../shared/types/database';
import type { TuitionCreateRequest, TuitionUpdateRequest } from '../../../shared/types/api';

const API_BASE = '/api/v1/tuition';
const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('quanly_truonghoc_token')}` });

export interface TuitionListParams {
  maHS?: string;
  semester?: string;
  year?: string;
  paymentStatus?: boolean;
}

export interface InvoiceCreatePayload {
  tuitionId: number;
  templateCode: string;
  invoiceSeries: string;
  sellerTaxCode: string;
  buyerName?: string;
  buyerAddressLine?: string;
  buyerEmail?: string;
  buyerPhoneNumber?: string;
}

export async function list(params?: TuitionListParams): Promise<TuitionFee[]> {
  const { data } = await axios.get(API_BASE, { params, headers: authHeaders() });
  return data?.data || [];
}

export async function create(dataReq: TuitionCreateRequest): Promise<number> {
  const { data } = await axios.post(API_BASE, dataReq, { headers: authHeaders() });
  return data?.data?.id || 0;
}

export async function update(id: number, dataReq: TuitionUpdateRequest): Promise<void> {
  await axios.put(`${API_BASE}/${id}`, dataReq, { headers: authHeaders() });
}

export async function issueInvoice(payload: InvoiceCreatePayload): Promise<any> {
  const { data } = await axios.post(`${API_BASE}/issue-invoice`, payload, { headers: authHeaders() });
  return data;
}

export async function getConfig(khoaHocId: string, semester: string, year: string): Promise<{ ItemName: string; UnitName?: string; UnitPrice: number } | null> {
  const { data } = await axios.get(`${API_BASE}/config`, { params: { khoaHocId, semester, year }, headers: authHeaders() });
  return data?.data || null;
}

export async function upsertConfig(payload: { KhoaHocID: string; Semester: string; Year: string; ItemName: string; UnitName?: string; UnitPrice: number }): Promise<void> {
  await axios.post(`${API_BASE}/config`, payload, { headers: authHeaders() });
}

export async function listConfigs(khoaHocId?: string): Promise<any[]> {
  const { data } = await axios.get(`${API_BASE}/configs`, { params: { khoaHocId }, headers: authHeaders() });
  return data?.data || [];
}

export async function deleteConfig(configId: number): Promise<void> {
  await axios.delete(`${API_BASE}/config/${configId}`, { headers: authHeaders() });
}

export const tuitionService = {
  list,
  create,
  update,
  issueInvoice,
  getConfig,
  upsertConfig,
  listConfigs,
  deleteConfig
};

export default tuitionService;


